import { render } from "./HelpDll.vue?vue&type=template&id=3571f256&scoped=true"
import script from "./HelpDll.vue?vue&type=script&lang=js"
export * from "./HelpDll.vue?vue&type=script&lang=js"

import "./HelpDll.vue?vue&type=style&index=0&id=3571f256&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3571f256"]])

export default __exports__